import styled from 'styled-components/native';
import { View, Text } from 'react-native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export const ButtonContainer = styled(View)`

`;

export const AssetsContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const AssetsShowContainer = styled(View)`
  display: flex;
  flex-direction: row;
  border: 4px solid black;
  border-radius: 10px;
  padding: 20px;
  gap: 40px;
  min-height: 240px;
`;

export const AssetLeftContainer = styled(View)`
  flex: 0.49;
  padding: 40px;
  background-color: ${elGray};
  border: black solid 1px;
  border-radius: 5px;
`;

export const AssetRightContainer = styled(View)`
  flex: 0.49;
  padding: 40px;
  background-color: ${elGray};
  border: black solid 1px;
  border-radius: 5px;
`;
